(function (Drupal, once) {

  /**
   * Main menu toggle.
   */
  Drupal.behaviors.toggleMainMenu = {
    attach: function (context) {
      once('toggleMainMenu', '.menu-toggle', context)
        .forEach(menuToggle => {
          menuToggle.addEventListener('click', (event) => {
            const headerLayout = document.getElementsByClassName('header-navbar__menu_container')[0]
            toggleOpen(menuToggle);
            toggleOpen(headerLayout);
          })
      })
    },
  }

  function toggleOpen(element) {
    element.getAttribute('aria-expanded') === 'true'
      ? element.setAttribute('aria-expanded', 'false')
      : element.setAttribute('aria-expanded', 'true')
  }

})(Drupal, once)
